import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import {
  labelJa,
  labelJaForCategory,
  formatFormValueDisplayForCategory,
} from "../lib/applicationFormFieldLabels";
import { filterFormEntries } from "../lib/applicationFormDisplay";
import "./ApplicationDetail.css";

function resolveMediaUrl(path) {
  if (!path) return null;
  const p = typeof path === "string" ? path : String(path);
  if (p.startsWith("http://") || p.startsWith("https://")) return p;
  const base = window.location.origin;
  return `${base}${p.startsWith("/") ? "" : "/"}${p}`;
}

const ApplicationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [appData, setAppData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/admin/applications/${id}/`)
      .then((res) => setAppData(res.data))
      .catch((err) => {
        console.error(err);
        setError("申請内容を取得できませんでした。");
      });
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">{error}</div>
        <button
          type="button"
          className="btn-back no-print"
          onClick={() => navigate("/admin/applications")}
        >
          戻る
        </button>
      </div>
    );
  }

  if (!appData) return <div className="mt-4">Loading...</div>;

  const form = appData.formData || {};
  const category = appData.category || "";
  const formEntries = filterFormEntries(category, form);

  const mynumberImg =
    appData.mynumber_image ||
    resolveMediaUrl(appData.attachment);

  const handleApprove = async () => {
    try {
      await api.post(`/admin/applications/${id}/approve/`);
      alert("承認しました");
      navigate("/admin/applications", { state: { refreshList: true } });
    } catch (e) {
      console.error(e);
      alert("承認処理でエラーが発生しました。");
    }
  };

  const handleReject = async () => {
    try {
      await api.post(`/admin/applications/${id}/reject/`);
      alert("却下しました");
      navigate("/admin/applications", { state: { refreshList: true } });
    } catch (e) {
      console.error(e);
      alert("却下処理でエラーが発生しました。");
    }
  };

  return (
    <div className="container mt-4 application-detail-page">
      <div id="application-print-root">
        <h2 className="mb-3 application-detail-title">{appData.title}</h2>

        <div className="card p-4 mb-3">
          <p>
            <strong>社員コード:</strong> {appData.applicant_memberId}
          </p>
          <p>
            <strong>申請者:</strong> {appData.applicant_name}
          </p>
          
          {/*}
          <p>
            <strong>申請名:</strong> {appData.title}
          </p>
          */}
          <p>
            <strong>申請日:</strong>{" "}
            {(appData.submitted_at || appData.created_at)
              ? new Date(appData.submitted_at || appData.created_at).toLocaleDateString("ja-JP", { year: "numeric", month: "2-digit", day: "2-digit" })
              : "—"}
          </p>
        </div>

        <div className="card p-4 mb-4">
          <h4 className="application-detail-section-title">申請内容</h4>

          {(category === "MYNUMBER" || category === "joined") && mynumberImg && (
            <div className="application-detail-mynumber-image">
              <strong className="application-detail-image-caption">マイナンバー確認書類（画像）</strong>
              <img src={mynumberImg} alt="マイナンバー確認書類" className="application-detail-img" />
            </div>
          )}

          {category === "FAMILY" && Array.isArray(appData.family_mynumbers) && appData.family_mynumbers.length > 0 && (
            <div className="application-detail-family-mynumbers">
              <strong className="application-detail-image-caption">家族のマイナンバー</strong>
              {appData.family_mynumbers.map((fm, i) => (
                <div key={i} className="application-detail-family-mynumber-row" style={{ marginTop: 12, paddingTop: 12, borderTop: "1px solid #e2e8f0" }}>
                  <div className="application-detail-field">
                    <span className="application-detail-label">続柄・氏名：</span>
                    <span className="application-detail-value">{[fm.relation, fm.nameKanji].filter(Boolean).join(" ") || "—"}</span>
                  </div>
                  <div className="application-detail-field">
                    <span className="application-detail-label">マイナンバー：</span>
                    <span className="application-detail-value">{fm.myNumber || "—"}</span>
                  </div>
                  {fm.image && (
                    <img src={fm.image} alt={`${fm.relation} ${fm.nameKanji} マイナンバー`} className="application-detail-img" />
                  )}
                </div>
              ))}
            </div>
          )}

          {formEntries.length === 0 &&
            !((category === "MYNUMBER" || category === "joined") && mynumberImg) &&
            !(category === "FAMILY" && Array.isArray(appData.family_mynumbers) && appData.family_mynumbers.length > 0) && (
            <p className="text-muted">申請内容がありません。</p>
          )}

          <div className="application-detail-body">
            {formEntries.map(([key, val]) => (
              <div key={key} className="application-detail-field">
                <span className="application-detail-label">{labelJaForCategory(category, key)}：</span>
                <span className="application-detail-value">
                  {formatFormValueDisplayForCategory(category, key, val)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="button-group no-print">
        <button type="button" className="btn-secondary-print" onClick={handlePrint}>
          印刷
        </button>
        {/*}
        <button type="button" className="btn-success" onClick={handleApprove}>
          承認する
        </button>
        <button
          type="button"
          className="btn-danger"
          onClick={category === "RETIREMENT" ? undefined : handleReject}
          disabled={category === "RETIREMENT"}
          style={category === "RETIREMENT" ? { backgroundColor: '#6c757d', borderColor: '#6c757d', cursor: 'not-allowed', opacity: 0.65 } : {}}
        >
          却下する
        </button>
        */}
        <button
          type="button"
          className="btn-back"
          onClick={() => navigate("/admin/applications")}
        >
          戻る
        </button>
      </div>
    </div>
  );
};

export default ApplicationDetail;
